import util from '../util'

let controller = 'SaldoBloqueadoHistorico'
export default Object.assign({}, util.GetCrud(controller, null))